import { render, staticRenderFns } from "./BlujayBcaMasterLocationIndex.vue?vue&type=template&id=16ea1136&scoped=true&"
import script from "./BlujayBcaMasterLocationIndex.vue?vue&type=script&lang=js&"
export * from "./BlujayBcaMasterLocationIndex.vue?vue&type=script&lang=js&"
import style0 from "./BlujayBcaMasterLocationIndex.vue?vue&type=style&index=0&id=16ea1136&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ea1136",
  null
  
)

export default component.exports